import Preview from './preview'

export { Preview }

const components = [Preview]

const install = (App) => {
    components.forEach((item) => {
        App.component(item.name, item);
    });
};

export default {
    install
}